import generateUrl from "@utils/generateUrl";

const WebPaths = {
    home: '/',
    aboutUs: '/about-us',
    contactUs: '/contact-us',
    category: (slug, params = {}) => {
        const baseCategoryUrl = slug ? `/product-category/${slug}` : `/product-category`;
        const queryString = generateUrl(params);
        return queryString ? `${baseCategoryUrl}${queryString}` : baseCategoryUrl;
    },
    tag: (slug, params = {}) => {
        const baseCategoryUrl = slug ? `/product-tag/${slug}` : `/product-tag`;
        const queryString = generateUrl(params);
        return queryString ? `${baseCategoryUrl}${queryString}` : baseCategoryUrl;
    },
    products: (params, currentParams) => params ? currentParams ? `/products${currentParams}${generateUrl(params, currentParams)}` : `/products${generateUrl(params)}` : "/products",
    product: (slug) => slug ? `/product/${slug}` : '/product',
    customizedDoor: '/customized-door',
    articles: (categorySlug) => categorySlug ? `/articles/${categorySlug}` : '/articles',
    article: (slug) => slug ? `/article/${slug}` : '/article',
    commercialPartner:(slug) => slug ? `/commercial-partner/${slug}` : '/commercial-partner',
    commercialPartners:(slug) => slug ? `/commercial-partners/${slug}` : '/commercial-partners',
    services: (categorySlug) => categorySlug ? `/services/${categorySlug}` : '/services',
    service: (slug) => slug ? `/service/${slug}` : '/service',
    catalogs: (categorySlug) => categorySlug ? `/catalogs/${categorySlug}` : '/catalogs',
    guide: '/guide',
    rules: '/rules',
    gallery: (id)=> id ? `/gallery?category=${id}` : '/gallery',
    cart: '/cart',
    shipping: '/shipping',
    payment: '/payment',
    paymentResult: '/payment-result',
    catalogues: '/catalog',
    businessGallery:"/business-gallery",
    customerBrand: '/parties-contract',
    ReservationRequest:(param)=> param  ? `/reservation-request${param}` : "/reservation-request",
    links: (code) => code ? `/links/${code}` : '/links',
    errors: {
        404: '/404',
        401: '/401',
        403: '/403',
        500: '/500',
    }
}

export default WebPaths
